import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { saveLastVisitedPage } from '../../utils/navigation.utils';

/**
 * NavigationTracker Component
 * Tracks the current page and saves it as the last visited page
 * This is used for the "last_visited" redirect option
 */
const NavigationTracker: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    // Save the current page as last visited
    saveLastVisitedPage(location.pathname);
  }, [location.pathname]);

  return null; // This component doesn't render anything
};

export default NavigationTracker;

